import { Injectable, Inject } from '@angular/core';

import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Account, AccountRelation } from '../../lib/interface';

@Injectable()
export class AdminService {
  private RequestUri: any;
  constructor(
    private http: HttpClient,
    @Inject('RequestJson') private RequestJson
  ) {
    const user = this.RequestJson.user;
    this.RequestUri = {
      check: this.RequestJson.my.check,
      logout: user.logout,
      login: user.login
    };
  }
  login () {
    return this.http.post(this.RequestUri.login, {});
  }
  logout () {
    return this.http.post(this.RequestUri.logout, {});
  }
  list (region: string) {
    return this.http.get(this.RequestUri.check + '?region=' + region);
  }
}



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/layout/admin/admin.service.ts